import React from 'react';

import { genders } from 'lib/constants/constants';

import Input from 'components/shared/Input/Input';
// import DatePopover from 'components/shared/Popovers/Date/DatePopover';
import Select from 'components/shared/Select/Select';

const InviteForm = ({ formik }) => (
  <div className="flex flex-col gap-4 px-4 py-4">
    <div className="grid grid-cols-2 gap-4">
      <Input
        label="First name"
        placeholder="Enter first name"
        name="f_name"
        required
        value={formik.values.f_name}
        onChange={formik.handleChange}
        error={formik.touched.f_name && formik.errors.f_name}
      />
      <Input
        label="Last name"
        placeholder="Enter last name"
        name="l_name"
        required
        value={formik.values.l_name}
        onChange={formik.handleChange}
        error={formik.touched.l_name && formik.errors.l_name}
      />
    </div>
    <div className="grid grid-cols-2 gap-4">
      {/* <DatePopover
        label="Date of birth"
        name="dob"
        value={formik.values.dob}
        onChange={(v) => formik.setFieldValue('dob', v)}
      /> */}
      <Select
        label="Gender"
        placeholder="Select gender"
        options={genders}
        value={
          formik.values.gender ? { value: formik.values.gender, label: formik.values.gender } : null
        }
        onChange={(o) => formik.setFieldValue('gender', o?.value)}
      />
    </div>
    <div className="grid grid-cols-2 gap-4">
      <Input
        label="Email"
        placeholder="Enter email address"
        name="email"
        required
        value={formik.values.email}
        onChange={formik.handleChange}
        error={formik.touched.email && formik.errors.email}
      />
      <Input
        label="Phone number"
        placeholder="Enter phone number"
        name="phone"
        value={formik.values.phone}
        onChange={formik.handleChange}
      />
    </div>
  </div>
);

export default InviteForm;
